import React, { useEffect, useMemo } from "react";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { useHistory } from "react-router-dom";

import "@react-pdf-viewer/core/lib/styles/index.css";

export default function PDFViewer(props) {
  const isMobile = useMemo(() => {
    return document.body.clientWidth <= 750;
  }, []);

  const url = useMemo(() => {
    return props.link || props.location?.useProps?.fileUrl || props.fileUrl;
  }, [props]);

  return isMobile ? (
    <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
      <div id="pdf-viewer">
        <Viewer fileUrl={url} />
      </div>
    </Worker>
  ) : (
    <div
      style={{
        width: "90%",
        height: "90%",
        margin: "auto",
        marginTop: "1rem",
        paddingTop: "1rem",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <iframe
        title="PDF Viewer"
        id="pdf_iframe"
        src={url}
        width="90%"
        height="800px"
      ></iframe>
    </div>
  );
}
